import { MatPaginatorIntl } from '@angular/material/paginator';

export function ItalianPaginator() {
  const italianPaginatorIntl = new MatPaginatorIntl();

  italianPaginatorIntl.itemsPerPageLabel = 'Record per pagina:';
  italianPaginatorIntl.firstPageLabel = "Prima pagina";
  italianPaginatorIntl.lastPageLabel = "Ultima pagina";
  italianPaginatorIntl.previousPageLabel = "Pagina precedente";
  italianPaginatorIntl.nextPageLabel = "Pagina seguente";
  italianPaginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number)=> ((page * pageSize) + 1) + ' - ' + (((page + 1) * pageSize)<length ? ((page + 1) * pageSize): length ) +  ' su ' + length;

  return italianPaginatorIntl;
}
